import { Functions, httpsCallable } from "firebase/functions";

export interface VerifyLoginCodePayload {
  /** The same identifier the code was requested for. */
  identifier: string;
  /** The 6-digit code the student received. */
  code: string;
  /** Stable idempotency key reused if the callable response is lost. */
  requestId: string;
}

export interface VerifyLoginCodeResponse {
  uid: string;
  /** Firebase custom token — sign in with `loginWithToken` from AuthContext. */
  customToken: string;
}

/**
 * Calls the `verifyLoginCode` backend callable, which exchanges a one-time
 * sign-in code for a Firebase custom token (same mechanism registration
 * uses). UI callers translate stable `details.reason` metadata from any
 * `FirebaseError` rather than rendering backend text directly.
 */
export default async function verifyLoginCode(
  payload: VerifyLoginCodePayload,
  functions: Functions
): Promise<VerifyLoginCodeResponse> {
  const callable = httpsCallable<
    VerifyLoginCodePayload,
    VerifyLoginCodeResponse
  >(functions, "verifyLoginCode");
  const result = await callable(payload);
  return result.data;
}
